import React, { Component } from "react";

export default class Extracurricular extends Component {
  render() {
    return (
      <div>
        <section
          className="colorlib-extracurricular"
          data-section="extracurricular"
        >
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">Other Work</span>
                <h2 className="colorlib-heading animate-box">
                  Extracurricular Activities
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-1">
                        <i className="icon-pen2"></i>
                      </div>

                      <div className="timeline-label">
                        <h2>
                          <a href="#">President, Student Body Government</a>{" "}
                          <span>April 2017 - April 2018</span>
                        </h2>
                        <p>
                          • Student Body Government is an apex body which
                          governs the 26 student run professional clubs and
                          committees with its 150 members at Dhirubhai Ambani
                          Institute of Information and Communication Technology{" "}
                          <br />• Convened meetings of the Student Body
                          Government <br />• Took up student issues and
                          initiatives to the university administration <br />•
                          Supervised all activities carried out by student clubs
                          and committees <br />• Helped manage the organization
                          of the annual festival of the university that attracts
                          a crowd of around 10,000 from across the country
                        </p>
                      </div>
                    </div>
                  </article>

                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-2">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <a href="#">President, Sports Committee</a>{" "}
                          <span>April 2017 - April 2018</span>
                        </h2>
                        <p>
                          • Managed a team of 10 student members who are
                          responsible for all Sports related activity in the
                          university and the upkeep of all Sports Infrastructure
                          on campus <br />• Managed and hosted a 4-day sports
                          festival every year for 3 years which attracts a crowd
                          of around 4000 students on campus
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <a href="#">Content Writer, The SportsRush</a>{" "}
                          <span>July 2017 - August 2018</span>
                        </h2>
                        <p>
                          • Researched and wrote sports articles on current
                          affairs for an online sports{" "}
                          <a href="https://thesportsrush.com/" target="_blank">
                            website
                          </a>
                          <br />• Published over 100 articles for Tennis,
                          Cricket and Football
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-1">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <a href="#">Captain, DA-IICT Cricket Team</a>{" "}
                          <span>May 2017 - April 2018</span>
                        </h2>
                        <p>
                          • Led the DA-IICT Cricket Team of 20 players in
                          multiple tournaments across India
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-2">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <a href="#">Member, State Cricket Team</a>{" "}
                          <span>2008, 2009, 2010</span>
                        </h2>
                        <p>
                          • Represented and jointly led the Gujarat State
                          Cricket Team at sports events across India for 3 years{" "}
                          <br />• Led the District Cricket Team of 25 players
                          for a year
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
